import {Component, HostListener, inject, output, Signal} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {NgClass} from '@angular/common';
import {environment} from '../../../environments/environment.local';
import {ProfileSync} from '../../auth/services/profile-sync';
import {ILoginResponse} from '../../auth/models/i-login-response';
import {toSignal} from '@angular/core/rxjs-interop';
import {filter, map} from 'rxjs';

@Component({
  selector: 'dm-header',
  imports: [
    RouterLink,
    NgClass
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  profileSync: ProfileSync = inject(ProfileSync);
  router: Router = inject(Router);

  hideSidebar = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => {
        const url = (event as NavigationEnd).urlAfterRedirects;
        // Nascondi se è la root OPPURE se inizia con /auth
        return url === '/' || url.startsWith('/auth');
      })
    ),
    { initialValue: this.router.url === '/' || this.router.url.startsWith('/auth') }
  );

  openSidebar = output<void>();

  user: Signal<ILoginResponse | null> = this.profileSync.user;
  isLogged: Signal<boolean> = this.profileSync.isLogged;

  showProfileMenu: boolean = false;

  logout(): void {
    this.profileSync.logout();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showProfileMenu) return;

    const clickedElement = event.target as HTMLElement;
    const isClickInsideMenuContainer = clickedElement.closest('#profile-icon');

    if (!isClickInsideMenuContainer) this.showProfileMenu = false;
  }

  protected readonly environment = environment;
}
